module.exports = __webpack_public_path__ + "static/media/newform2.478a91fc.png";